export default __webpack_public_path__ + "static/media/logo-zammad.e8bd1eb2.png";